@let definicao = campo();

<div class="solicitacao-campo">
  <label class="solicitacao-rotulo" [attr.for]="idCampo()">
    {{ definicao.desNomeCps }}
    @if (definicao.bitObrigatorioCps) {
      <span class="solicitacao-obrigatorio" aria-hidden="true">*</span>
    }
  </label>

  @switch (definicao.desTipoCps) {
    @case ('Texto Longo') {
      <textarea
        class="solicitacao-input solicitacao-textarea"
        rows="4"
        [id]="idCampo()"
        [value]="valor()"
        [attr.maxlength]="limiteTextoLongo"
        [attr.aria-required]="definicao.bitObrigatorioCps"
        [attr.aria-invalid]="!!erro()"
        [attr.aria-describedby]="erro() ? idErro() : null"
        (input)="aoDigitar($event)"
        (blur)="aoSair()"
      ></textarea>
      <p class="solicitacao-contador">{{ valor().length }}/{{ limiteTextoLongo }}</p>
    }

    @case ('Número') {
      <input
        class="solicitacao-input"
        type="text"
        inputmode="decimal"
        [id]="idCampo()"
        [value]="valor()"
        [attr.aria-required]="definicao.bitObrigatorioCps"
        [attr.aria-invalid]="!!erro()"
        [attr.aria-describedby]="erro() ? idErro() : null"
        (input)="aoDigitar($event)"
        (blur)="aoSair()"
      />
    }

    @case ('Data') {
      <input
        class="solicitacao-input"
        type="date"
        [id]="idCampo()"
        [value]="valor()"
        [attr.aria-required]="definicao.bitObrigatorioCps"
        [attr.aria-invalid]="!!erro()"
        [attr.aria-describedby]="erro() ? idErro() : null"
        (input)="aoDigitar($event)"
        (blur)="aoSair()"
      />
    }

    @case ('Seleção') {
      <select
        class="solicitacao-input"
        [id]="idCampo()"
        [value]="valor()"
        [attr.aria-required]="definicao.bitObrigatorioCps"
        [attr.aria-invalid]="!!erro()"
        [attr.aria-describedby]="erro() ? idErro() : null"
        (change)="aoDigitar($event)"
        (blur)="aoSair()"
      >
        <option value="">Selecione...</option>
        @for (opcao of definicao.opcoes; track opcao) {
          <option [value]="opcao" [selected]="opcao === valor()">{{ opcao }}</option>
        }
      </select>
    }

    @case ('Upload de Arquivo') {
      @if (arquivo(); as escolhido) {
        <div class="campo-arquivo-escolhido">
          <i-lucide name="paperclip" size="16" aria-hidden="true"></i-lucide>
          <span class="campo-arquivo-nome">{{ escolhido.name }}</span>
          <span class="campo-arquivo-tamanho">{{ formatarTamanho(escolhido.size) }}</span>
          <button
            type="button"
            class="campo-arquivo-remover"
            [attr.aria-label]="'Remover ' + escolhido.name"
            (click)="removerArquivo()"
          >
            <i-lucide name="trash-2" size="16" aria-hidden="true"></i-lucide>
          </button>
        </div>
      } @else {
        <input
          class="solicitacao-input campo-arquivo-input"
          type="file"
          [id]="idCampo()"
          [attr.accept]="accept()"
          [attr.aria-required]="definicao.bitObrigatorioCps"
          [attr.aria-invalid]="!!erro()"
          [attr.aria-describedby]="erro() ? idErro() : idCampo() + '-dica'"
          (change)="aoEscolherArquivo($event)"
        />
        <p class="campo-arquivo-dica" [id]="idCampo() + '-dica'">
          Formatos: {{ formatosTexto() }} · até {{ tetoTexto() }}
        </p>
      }
    }

    @default {
      <input
        class="solicitacao-input"
        type="text"
        [id]="idCampo()"
        [value]="valor()"
        [attr.maxlength]="limiteTextoCurto"
        [attr.aria-required]="definicao.bitObrigatorioCps"
        [attr.aria-invalid]="!!erro()"
        [attr.aria-describedby]="erro() ? idErro() : null"
        (input)="aoDigitar($event)"
        (blur)="aoSair()"
      />
    }
  }

  @if (erro()) {
    <p class="solicitacao-erro" [id]="idErro()">{{ erro() }}</p>
  }
</div>
